const SUPPORTED_FIELD_TYPES = {
    boolean: "Boolean",
    number: "Number",
    text: "Text",
    bigtext: "BigText",
    date: "Date",
    birthdate: "BirthDate",
    choice: "Choice",
    multiplechoice: "MultipleChoice",
    gender: "Gender",
    country: "Country",
    social: "Social",
    phone: "Phone",
    email: "Email",
    conversion: "Conversion",
    photo: "Photo",
};

export const resolveFieldType = (dataType) => {
    const normalizedType = String(dataType || "").trim().toLowerCase();
    return SUPPORTED_FIELD_TYPES[normalizedType] || "Text";
};
